export { default } from "./app-switch.component";
export * from "./app-switch.types";
